export const socialLinks = [
  {
    name: 'Instagram',
    icon: 'fa-brands fa-instagram',
    href: 'https://www.instagram.com/metameni.co/',
  },
  {
    name: 'Facebook',
    icon: 'fa-brands fa-facebook-f',
    href: 'https://www.facebook.com/metameni.co',
  },
  {
    name: 'X',
    icon: 'fa-brands fa-x-twitter',
    href: 'https://x.com/metameni',
  },
  {
    name: 'YouTube',
    icon: 'fa-brands fa-youtube',
    href: 'https://www.youtube.com/@metameni',
  },
  {
    name: 'LinkedIn',
    icon: 'fa-brands fa-linkedin-in',
    href: 'https://www.linkedin.com/company/metameni',
  },
];
